export default __webpack_public_path__ + "static/media/lady-walking.7a2340d1.png";